import { LocaleProvider } from '../providers/LocaleProvider';
import ThemeProvider from '../providers/ThemeProvider';
import React from 'react';
import PropTypes from 'prop-types';
var Providers = function (props) {
    return (React.createElement(LocaleProvider, { locale: props.locale, locales: props.locales },
        React.createElement(ThemeProvider, null, props.children)));
};
Providers.propTypes = {
    locale: PropTypes.string.isRequired,
    locales: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
};
export default Providers;
